/* eslint-disable import/prefer-default-export */
import queryString from 'query-string';
import { generatePath } from 'react-router-dom';

import {
  API_CUSTOM_LOCATION_LIST_URL,
  API_CUSTOM_LOCATION_LISTS_URL,
  API_LOCATION_DESTROY_ALL_URL,
} from '../../constants/apiUrls';
import { deleteRequestJSON, getRequestJSON, postRequestJSON } from '../../util/services';

interface QueryParams {
  page?: number;
  perPage?: number;
}

export const getAll = (apiHost: string, adGroupId: number, { page, perPage }: QueryParams): Promise<any> => {
  const queryParams = `?${queryString.stringify({
    page: page + 1,
    per_page: perPage,
  })}`;
  return getRequestJSON(
    apiHost,
    generatePath(API_CUSTOM_LOCATION_LISTS_URL, { adGroupId: adGroupId.toString(), '*': queryParams })
  );
};

export const create = (apiHost: string, adGroupId: number, locationList: any, signal?: AbortSignal): Promise<any> =>
  postRequestJSON(
    apiHost,
    generatePath(API_CUSTOM_LOCATION_LISTS_URL, { adGroupId: adGroupId.toString(), '*': '' }),
    locationList,
    undefined,
    { signal }
  );


export const remove = (apiHost: string, locationListId: number, signal?: AbortSignal): Promise<any> =>
  deleteRequestJSON(apiHost, generatePath(API_CUSTOM_LOCATION_LIST_URL, { id: locationListId.toString(), '*': '' }), {
    signal,
  });

export const removeAll = (apiHost: string, adGroupId: number, signal?: AbortSignal): Promise<any> =>
  deleteRequestJSON(apiHost, generatePath(API_LOCATION_DESTROY_ALL_URL, { adGroupId: adGroupId.toString() }), {
    signal,
  });
